<template>
  <div>
    <leo-input
      type="text"
      id="password"
      v-model.trim="$v.password.$model"
      :label="passwordLabel"
      :placeholder="placeholderMessage"
      password
      :error="isError"
      v2
      errorIcon
      @blur="$emit('onBlur')"
    >
      <template v-slot:error>
        <div v-if="$v.password.$dirty && !$v.password.required">
          {{ passwordInputErrMessage.mandatory }}
        </div>
        <div v-else-if="!$v.password.customValidator">
          {{ passwordInputErrMessage.someSpecialChar }}
        </div>
      </template></leo-input
    >
  </div>
</template>

<script>
import { VueLeoInput } from "@greateasternlife/leo-input";
import { mapState } from "vuex";
export default {
  name: "PasswordInput",
  components: {
    "leo-input": VueLeoInput,
  },
  computed: {
    ...mapState("alert", {
      isActive: (state) => state.isActive,
    }),
  },
  props: {
    isError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      passwordLabel: this.$getConstant.labels?.password,
      placeholderMessage: this.$getConstant.signInProp?.passwordPlaceholder,
      passwordInputErrMessage: this.$getConstant?.messages?.errorMessage,
    };
  },
  mounted() {
    const passwordEl = document.getElementById("password"); //  this.$refs.usernameRef;
    const view = this;
    this.observeElement(passwordEl, "value", function (oldValue, newValue) {
      view.$v.password.$model = newValue;
    });
  },
  watch: {
    isActive(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== undefined) {
        if (!newVal && oldVal) {
          this.$v.password.$model = "";
          setTimeout(() => this.$v.password.$reset(), 10);
        }
      }
    },
  },
  inject: ["$v"],
  emits: ["onBlur"],
  methods: {
    observeElement(element, property, callback, delay = 0) {
      /* eslint-disable */
      let elementPrototype = Object.getPrototypeOf(element);
      if (elementPrototype.hasOwnProperty(property)) {
        let descriptor = Object.getOwnPropertyDescriptor(
          elementPrototype,
          property
        );
        Object.defineProperty(element, property, {
          get: function () {
            return descriptor.get.apply(this, arguments);
          },
          set: function () {
            let oldValue = this[property];
            descriptor.set.apply(this, arguments);
            let newValue = this[property];
            if (typeof callback == "function") {
              if (oldValue !== newValue)
                setTimeout(callback.bind(this, oldValue, newValue), delay);
            }
          },
        });
      }
    },
  },
};
</script>

<style></style>
